<template>
    <div>
        <div v-if="!variants.length" class="has-text-centered">
            <h2 class="is-size-4 ">Todavia no hay variantes para este producto....</h2>
        </div>
        <div v-if="!attributes.length" class="has-text-centered">
            <h2 class="is-size-4 ">Tienes que crear algunos atributos antes de crear variantes para este producto.</h2>
        </div>
        <VariantsFormEl
        v-if="attributes.length"
        v-for="(x,i) in variants"
        :key="x.id"
        :index="i"
        :data="x"
        :newVar="false"
        :variantDetail="variantDetail" 
        :attributes="attributes"
        @getProd="fetchProd"
        @reFetchVariants="emitReFetch"/>

        <b-modal :active.sync="isAddModalActive"  scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">
                <div class="modal-card-body">

                    <p class="modal-card-title m-t-10 has-text-centered">Agregar mas variantes</p>

                    <VariantsFormEl
                    v-for="(x,i) in newVariants"
                    :key="x.id"
                    :index="i"
                    :data="x" 
                    :newVar="true"
                    :attributes="attributes"
                    @deleteNewVar="deleteNewVariant"
                    @reFetchVariants="emitReFetch"/>
                
                    <div class="columns is-centered">
                        <div class="column has-text-centered">
                            <b-button
                            type="is-text"
                            @click="addNewVariant">
                                <b-icon
                                icon="plus"
                                size="is-small">
                                </b-icon>
                               Nueva fila
                            </b-button>
                        </div>
                    </div>
                    <div class="columns is-centered">
                        <div class="column has-text-centered">
                            <b-button 
                            type="is-primary"
                            @click="createNewVariants"
                            >
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar
                            </b-button>
                        </div>
                    </div>
                </div>
                
            </div>
        </b-modal>
        
        <div v-if="attributes.length" class="columns is-centered">
            <div class="column is-full has-text-centered">
                <b-button 
                type="is-primary" 
                rounded
                @click="isAddModalActive=true">
                    <b-icon 
                    size="is-small"
                    icon="plus">
                    </b-icon>
                    Agregar nuevas variantes
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import {getHandler, postHandler, deleteHandler} from "./../../../../services/http.js"
import VariantsFormEl from "./VariantsFormEl.vue"

export default {
    components:{
        VariantsFormEl
    },
    props:{
        variantList:{
            type:String,
            default:""
        },
        variantDetail:{
            type:String,
            default:""
        },
        variantCreate:{
            type:String,
            default:""
        },
        attributesList:{
            type:String,
            default:""
        },
        attributes:{
            type:Array,
            default:""
        },
        variants:{
            type:Array,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            isAddModalActive:false,
            newVariants:[]
        }
    },
    methods:{
        fetchProd(){
            this.$emit("getProd")
        },
        addNewVariant(){
            this.newVariants.push({
                price:0,
                cost:0,
                compareAt:0,
                hasDifPricing:false
            })
        },
        deleteNewVariant(index){
            this.newVariants.splice(index, 1)
        },
        emitReFetch(){
            this.$emit("reFetchVariants")
        },
        async createNewVariants(){
            let error={
                resource:"notify"
            }
            let success={
                resource:"notify"
            }
            this.newVariants.forEach((item)=>{
                item.values = []
                this.attributes.forEach((attr)=>{
                    item.values.push(
                        item[attr.title]
                    )
                    delete item[attr.title]
                })
            })
            console.log(this.newVariants)
            let response = await postHandler(this.variantCreate, this.newVariants, {success, error})
            console.log(response)
            this.newVariants=[]
            this.isAddModalActive = false
            this.$emit("getProd")
            this.$emit("reFetchVariants")
        },
    },
    
}
</script>
